import React from "react";
import classNames from "classnames";
import "./AboutSigner.scss";

export const InputFeedback = ({ error }) =>
  error ? <div className={classNames("input-feedback")}>{error}</div> : null;

export const RadioButton = ({
  field: { name, onChange, onBlur, value },
  id,
  label,
  className,
  ...props
}) => {
  return (
    <div>
      <label className="radio-label">
        <input
          name={name}
          id={id}
          type="radio"
          value={id}
          checked={id === value}
          onChange={onChange}
          onBlur={onBlur}
          className="label-input"
          {...props}
        />
        <span className="label-span">
          <span className="icon fa fa-check" aria-hidden="true" />
          {label}
        </span>
      </label>
    </div>
  );
};

export const RadioButtonGroup = ({ error, touched, label, children }) => {
  //props === value, className
  // const classes = classNames(
  //   "input-field",
  //   {
  //     "is-success": value || (!error && touched),
  //     "is-error": !!error && touched
  //   },
  //   className
  // );

  return (
    <div>
      <legend>{label}</legend>
      {children}
      {touched && <InputFeedback error={error} />}
    </div>
  );
};
